import { API } from "@/lib/api";

/* One voice turn over SSE: POST audio (or text) → events {type: transcript|tool|delta|actions|audio|bye|error|done}. */
export async function voiceTurn({ blob, text, lang = "tr" }, onEvent, signal) {
  const fd = new FormData();
  if (blob) fd.append("file", blob, "turn.webm"); else fd.append("text", text);
  fd.append("language", lang);
  const res = await fetch(`${API}/voice/turn`, { method: "POST", body: fd, credentials: "include", signal });
  if (!res.ok) {
    let msg = `HTTP ${res.status}`;
    try { msg = (await res.json()).detail || msg; } catch (e) {}
    throw new Error(msg);
  }
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    let i;
    while ((i = buf.indexOf("\n\n")) >= 0) {
      const chunk = buf.slice(0, i); buf = buf.slice(i + 2);
      for (const line of chunk.split("\n")) if (line.startsWith("data:")) onEvent(JSON.parse(line.slice(5)));
    }
  }
}

export const b64ToUrl = (b64, type = "audio/mpeg") =>
  URL.createObjectURL(new Blob([Uint8Array.from(atob(b64), (c) => c.charCodeAt(0))], { type }));
